module.exports = __webpack_public_path__ + "static/media/aribert.1c054249.png";